import React from 'react'
import block from 'bem-cn-lite'
import { users, statuses } from '../data'
import ReportChartSection from './ReportChartSection'
import { I18n } from 'react-i18next';

const b = block('ReportChart');
const item = block('ReportChartItem');

class ReportChart extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            tooltip: {
                visible: false,
                top: 0,
                left: 0,

            }
        }
        
        this.onSectionOver = this.onSectionOver.bind(this)
        this.onSectionLeave = this.onSectionLeave.bind(this)
    }

    onSectionOver(target, data) {
        
        const tooltip = {
            top: target.offsetTop,
            left: target.offsetLeft + target.offsetWidth / 2,
            visible: true,
            content: {
                username: data.username,
                status: statuses.find(s => s.id === data.status).name,
                count: data.count
            }
        }

        this.setState({
            tooltip
        })
    }

    onSectionLeave() {
        this.setState({
            tooltip: {
                visible: false,
                content: null
            }
        })
    }

    componentDidUpdate() {
        
        if(this.state.tooltip.visible) {
            this.tooltipRef.style.top = this.state.tooltip.top - this.tooltipRef.offsetHeight - 15 + 'px';
            this.tooltipRef.style.left = this.state.tooltip.left - this.tooltipRef.offsetWidth / 2 + 'px';
        }
    }

    getMaxTasksCount(users) {
        let maxTasksCount = 0;

        users.forEach(user => {
            let max = user.tasks.reduce((prev, current) => {
                if(typeof prev === 'object') {
                    return prev.count + current.count;
                } else {
                    return prev + current.count;
                }
            })

            if(max > maxTasksCount) {
                maxTasksCount = max;
            }
        })

        return maxTasksCount;
    }

    render() {
        let maxTasksCount = this.getMaxTasksCount(users) + 1;

        //Fill array with numbers range
        const gridLevels = Array.apply(null, { length: maxTasksCount + 1 }).map(Number.call, Number).reverse();
        
        const tooltipStyle = {
            visibility: this.state.tooltip.visible ? 'visible' : 'hidden',
            opacity: this.state.tooltip.visible ? 1 : 0,
        }
        var tooltipData = {}

        if(this.state.tooltip.content) {
            tooltipData = this.state.tooltip.content
        }
      
        return (
            <I18n ns={ ['report'] }>
                {
                    (t) => (
                        <div className={b()}>
                            <div className={b('tooltip')} ref={(el) => { this.tooltipRef = el; }} style={tooltipStyle}>
                                <div className={b('tooltip-name')}>{tooltipData.username}</div>
                                <div className={b('tooltip-status')}>{tooltipData.status}: {tooltipData.count}</div>
                            </div>
                            <div className={b('axis-label', { y: true })}>{t('report:taskCount')}</div>
                            <div className={b('field')}>
                                <div className={b('grid')}>
                                    {!this.props.isEmptyOut && gridLevels.map(level =>
                                        <div className={b('grid-level')} key={level}>
                                            <span className={b('grid-level-label')}>{level}</span>
                                        </div>
                                    )}
                                </div>
                                <div className={b('container', { empty: this.props.isEmptyOut })}>
            
                                    <div className={b('no-output', { hidden: !this.props.isEmptyOut })}>
                                        <img src="https://cdn.wrike.com/image/__cdnu/icon_grey_vector_fun_cactus.svg" alt="empty report"/>
            
                                        <p><b>{t('report:allClear')}</b></p>
                                        <p>{t('report:nothingToReport')}</p>
                                    </div>
            
                                    {!this.props.isEmptyOut && 
                                        <div className={b('items')}>
                                            {users.map(user =>
                                                <div className={item()} key={user.id}>
                                                    <div className={item('column')}>
                                                        {user.tasks.filter(task => task.count > 0).map((task, index) => 
                                                            <ReportChartSection 
                                                                key={index}
                                                                task={task}
                                                                total={maxTasksCount}
                                                                isActive={this.props.inactiveStatuses.indexOf(task.status) === -1}
                                                                username={user.name}
                                                                onSectionOver={this.onSectionOver}
                                                                onSectionLeave={this.onSectionLeave}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className={item('label')}>{user.name}</div>
                                                </div>
                                            )}
                                        </div>
                                    }
                                    
                                </div>
                            </div>
                            <div className={b('axis-label', { x: true })}>{t('report:assignee')}</div>
                        </div>
                    )
                }
            </I18n>
        )
    }

}

export default ReportChart;